import { render, staticRenderFns } from "./ContentDetailPaymentsList.vue?vue&type=template&id=73f7b9ac"
import script from "./ContentDetailPaymentsList.vue?vue&type=script&lang=js"
export * from "./ContentDetailPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f7b9ac')) {
      api.createRecord('73f7b9ac', component.options)
    } else {
      api.reload('73f7b9ac', component.options)
    }
    module.hot.accept("./ContentDetailPaymentsList.vue?vue&type=template&id=73f7b9ac", function () {
      api.rerender('73f7b9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/details/components/ContentDetailPaymentsList.vue"
export default component.exports